module.exports = __webpack_public_path__ + "static/media/sportsimg.a6edd014.svg";